import { useCallback, useMemo } from "react";

import useNavigateToImportSummary from "../../../hooks/useNavigateToImportSummary";
import useFileImportStore from "../../../stores/fileImportStore";

export default function useCancelImport() {
  const successfulImports = useFileImportStore((s) => s.successfulImports);
  const navigateToImportSummary = useNavigateToImportSummary();

  const cancel = useCallback(() => {
    if (successfulImports && successfulImports.length > 0) {
      navigateToImportSummary();
    } else {
      useFileImportStore.getState().clearState(true);
    }
  }, [navigateToImportSummary, successfulImports]);

  return useMemo(() => ({ cancel }), [cancel]);
}
